import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiMail } from "react-icons/fi";
import api from "../services/api";

const EmailVerification = () => {
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [isResending, setIsResending] = useState(false);
  const [resendNotice, setResendNotice] = useState("");

  useEffect(() => {
    const stateEmail = location.state?.email || "";
    setEmail(stateEmail);
  }, [location.state]);

  const handleResend = async () => {
    if (!username || !email) {
      setResendNotice("Please enter your username and email first.");
      return;
    }
    setIsResending(true);
    setResendNotice("");
    try {
      const response = await api.post("/verify-email/resend", { username, email });
      if (response.data?.status === "success") {
        setResendNotice(response.data?.message || "Verification email sent.");
      } else {
        setResendNotice("Unable to resend verification email.");
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Unable to resend verification email.";
      setResendNotice(message);
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="min-h-screen bg-[linear-gradient(135deg,#e0f2fe_0%,#e9d5ff_35%,#fce7f3_65%,#fed7aa_100%)] px-6 py-10">
      <div className="mx-auto flex w-full max-w-[900px] flex-col gap-8">
        <header className="flex items-center gap-3 rounded-3xl border border-white/60 bg-white/90 px-6 py-4 shadow-lg shadow-slate-200/60">
          <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[linear-gradient(135deg,var(--brand-blue)_0%,var(--brand-blue-2)_100%)] text-white">
            <FiMail />
          </div>
          <div className="text-lg font-semibold text-slate-900">
            RMC2 Emergency Care (ER)
          </div>
        </header>

        <div className="rounded-3xl border border-white/60 bg-white/90 p-8 shadow-lg shadow-slate-200/60">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-100 text-[var(--brand-blue)]">
              <FiMail />
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.3em] text-slate-400">
                Verification
              </p>
              <h1 className="text-2xl font-semibold text-slate-900">
                Verify your email address
              </h1>
            </div>
          </div>

          <p className="mt-5 text-sm leading-relaxed text-slate-600">
            We sent a verification link to your email. Please check your inbox
            and follow the link to activate your account.
          </p>

          <div className="mt-5 flex flex-col gap-2">
            <label className="text-xs font-semibold text-slate-500">
              Username
            </label>
            <input
              type="text"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              placeholder="Username"
              className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700 placeholder:text-slate-400 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200"
            />
          </div>

          <div className="mt-4 flex flex-col gap-2">
            <label className="text-xs font-semibold text-slate-500">
              Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="Email Address"
              className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700 placeholder:text-slate-400 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200"
            />
          </div>

          <div className="mt-6 flex flex-wrap items-center justify-end gap-3">
            <button
              type="button"
              onClick={handleResend}
              disabled={isResending}
              className="rounded-2xl border border-slate-200 px-5 py-2 text-sm font-semibold text-slate-500 transition hover:border-slate-300"
            >
              {isResending ? "Resending..." : "Resend Email"}
            </button>
            <Link
              to="/login"
              className="rounded-2xl bg-[var(--brand-orange)] px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-orange-200 transition hover:bg-[var(--brand-orange-dark)]"
            >
              Back to Login
            </Link>
          </div>
          {resendNotice && (
            <p className="mt-3 text-sm text-slate-500">{resendNotice}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;
